module.exports = __webpack_public_path__ + "img/copy-icon.77dd4acc.svg";